import React, { Fragment } from 'react';
import { AppBar, Toolbar, Grid, makeStyles, Container } from '@material-ui/core';
import Logo from './Logo';

const useStyles = makeStyles({
  settingsBar: {
    height: "42px",
    backgroundColor: "#d7e9f1",
  },
  appBar: {
    backgroundColor: "#fff",
  },
  menuMainBar: {
    height: "102px",
    backgroundColor: "#fff",
    boxShadow: "0 0 4px 0 hsla(156,7%,87%,.4)",
  },
  negativeLeftMargin: {
    marginLeft: '-25px', 
    '@media (max-width:599px)': {
      marginLeft: '-16px',
    },
  },
})

export default function NavBar() {
  const classes = useStyles();
  return (
    <Fragment>      
      <Grid container alignItems="center" className={classes.menuMainBar}>
        <Container>
          <AppBar elevation={0} className={classes.appBar} position="static">
            <Toolbar className={classes.negativeLeftMargin}>
              <Logo />
            </Toolbar>
          </AppBar>
        </Container>
      </Grid>
    </Fragment>
  );
}